<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t('common.setting.security') }}</div>
      <!-- 登陆密码 -->
      <div class="items" v-if="isSuperAdmin ? isSuperAdmin : !isEnterpriseChildUser ? true : false">
        <div>
          <el-alert :closable="false" :title="$t('common.password.login')" type="success" show-icon>
          </el-alert>
          <div class="text">
            {{ $t('other.text.security.password.desc') }}
          </div>
        </div>
        <div>
          <el-button link type="primary" @click="changePassword"
          >{{ $t('common.update') }}
          </el-button
          >
        </div>
      </div>
      <!-- 手机绑定 -->
      <div class="items">
        <div v-if="userInfo.phone===''|| userInfo.phone===null">
          <el-alert :closable="false" :title="'['+$t('common.as16')+']'" type="error" show-icon>
          </el-alert>
          <div class="text">
            {{ $t('common.as16') }}
          </div>
        </div>
        <div v-else>
          <el-alert :closable="false" :title="$t('common.binding.phone')" type="success" show-icon>
          </el-alert>
          <div class="text">
            {{ $t('common.ph34', {phone: userInfo.phone}) }}
          </div>
        </div>
        <div v-if="userInfo.phone===''||userInfo.phone===null">
          <el-button link type="primary" @click="bindPhoneTo">{{ $t("common.setting.now") }}</el-button>
        </div>
        <div v-else>
          <el-button link type="primary" @click="unbindPhoneTo">{{ $t("common.unbind") }}</el-button>
        </div>
      </div>
      <!-- 邮箱绑定 -->
      <div class="items">
        <div v-if="userInfo.email===''||userInfo.email===null">
          <el-alert
              :closable="false"
              :title="'['+$t('common.setting.none')+']'"
              type="error"
              show-icon
          >
          </el-alert>
          <div class="text">
            {{ $t("other.text.security.email.desc") }}
          </div>
        </div>
        <div v-else>
          <el-alert :closable="false" :title="$t('common.binding.emailbox')" type="success" show-icon>
          </el-alert>
          <div class="text">
            {{ $t("other.text.security.email.desc") }}
          </div>
        </div>
        <div v-if="userInfo.email===''|| userInfo.email===null">
          <el-button link type="primary" @click="bindEmailTo">{{ $t("common.setting.now") }}</el-button>
        </div>
        <div v-else>
          <el-button link type="primary" @click="unbindEmailTo">{{ $t("common.unbind") }}</el-button>
        </div>
      </div>
      <!-- 选择语言 -->
      <div class="items">
        <div>
          <el-alert :closable="false" :title="$t('common.lang.select')" type="success" show-icon>
          </el-alert>
          <div class="selects">
            <el-select size="small" v-model="langLocal" @change="changeLang">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.key"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!--      注销-->
      <div class="items" v-if="isSuperAdmin ? isSuperAdmin : !isEnterpriseChildUser ? true : false">
        <div>
          <el-alert
              :closable="false"
              :title="$t('security.cancel.account')"
              type="warning"
              show-icon
          >
          </el-alert>
          <div class="text">
            {{ $t('security.cancel.des') }}
          </div>
        </div>
        <el-button link type="danger" @click="Logout">
          {{ $t("security.btn") }}
        </el-button>
      </div>
    </div>
    <!-- 修改密码 -->
    <Dialog
        v-model="dialogVisible"
        :title="$t('common.reset.password')"
        :dialogVisible="dialogVisible"
        :isHeadLine="false"
        :width="'450'"
        @update:dialogVisible="(val) => (dialogVisible = val)"
    >
      <template #content>
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :rules="rules"
            class="demo-ruleForm"
            :label-position="'top'"
            style="padding:0px 8px"
        >
          <el-form-item :label="$t('40021')" prop="password">
            <el-input size="small" type="password" v-model="ruleForm.password" show-password>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('sys.tip.input.newpassword')" prop="pass">
            <el-input
                size="small"
                v-model="ruleForm.pass"
                type="password"
                autocomplete="off"
                show-password
            />
          </el-form-item>
          <el-form-item :label="$t('sys.tip.input.password.again')" prop="checkPass">
            <el-input
                size="small"
                v-model="ruleForm.checkPass"
                type="password"
                autocomplete="off"
                show-password
            />
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <div class="bottom_btn">
          <el-button size="small" @click="cancelClick">{{ $t('common.cancel') }}</el-button>
          <el-button size="small" type="primary" @click="submit"
          >{{ $t("common.confirm") }}
          </el-button>
        </div>
      </template>
    </Dialog>
    <!-- 手机绑定-->
    <Dialog
        v-model="dialogVisiblePhone"
        :title="userInfo.phone ? ($t('common.phone') + $t('common.update')) : $t('common.binding.phone')"
        :dialogVisible="dialogVisiblePhone"
        :isHeadLine="false"
        :width="'450'"
        @close="closePhone"
        @update:dialogVisible="(val) => (dialogVisiblePhone = val)"
    >
      <template #content>
        <el-form
            ref="ruleFormRefPhone"
            :model="ruleFormPhone"
            :rules="rulesPhone"
            class="demo-ruleForm"
            :label-position="'top'"
            style="padding:0px 8px"
        >
          <el-form-item :label="$t('common.phone.number')" prop="phone">
            <CountrySelect @changeSelect="getSelectValue"></CountrySelect>
            <el-input
                style="width: calc(100% - 95px)"
                size="small"
                v-model="ruleFormPhone.phone"
                :placeholder="$t('sys.tip.input.phone')"
                :disabled="userInfo.phone!==''"
            ></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('common.yzm')"
              prop="emailCode"
              :aria-placeholder="$t('sys.tip.input.sms.code')"
              id="sp_input"
          >
            <el-input
                size="small"
                v-model="ruleFormPhone.code"
                :placeholder="$t('90104')"
                :clearable="false"
                @keydown.enter.native="bindPhoneApis"
            >
              <template #suffix>
                <el-button type="primary" @click="sendPhone" :disabled="!showPhone" link
                           style="padding-right:15px;font-size: 12px">
                  <span v-if="showPhone">{{ $t('common.label.getsmscode') }}</span>
                  <span v-show="!showPhone">{{ countPhone }}s</span>
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <div class="bottom_btn">
          <el-button size="small" @click="cancelPhone">{{ $t('common.sss16') }}</el-button>
          <el-button size="small" type="primary" @click="bindPhoneApis"
          >{{ $t("common.confirm") }}
          </el-button
          >
        </div>
      </template>
    </Dialog>
    <!-- 邮箱绑定 -->
    <Dialog
        v-model="dialogVisibleEmail"
        :title="userInfo.email ? ($t('common.emailbox') + $t('common.update')) : $t('common.binding.emailbox')"
        :dialogVisible="dialogVisibleEmail"
        :isHeadLine="false"
        @update:dialogVisible="(val) => (dialogVisibleEmail = val)"
        :width="'450'"
        @close="closeEmail"
    >
      <template #content>
        <el-form
            style="margin: 0px 8px;"
            ref="ruleFormRefEmail"
            :model="ruleFormEmail"
            :rules="rulesEmail"
            :label-position="'top'"
        >
          <el-form-item :label="$t('common.emailbox')" prop="email">
            <el-input
                size="small"
                :disabled="userInfo.email"
                v-model="ruleFormEmail.email"
                :placeholder="$t('sys.tip.input.emailbox')"
            ></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('common.yzm')"
              prop="emailCode"
              :aria-placeholder="$t('90104')"
              id="sp_input"
          >
            <el-input
                size="small"
                v-model="ruleFormEmail.emailCode"
                :placeholder="$t('90104')"
                :clearable="false"
                @keydown.enter.native="bindEmailApis"
            >
              <template #suffix>
                <el-button type="primary" @click="send" :disabled="!show" link
                           style="padding-right: 15px;font-size: 12px">
                  <span v-if="show">{{ $t('common.label.getsmscode') }}</span>
                  <span v-show="!show">{{ count }}s</span>
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <div class="bottom_btn">
          <el-button size="small" @click="cancelEmail">{{ $t('common.sss16') }}</el-button>
          <el-button size="small" type="primary" @click="bindEmailApis">{{ $t("common.confirm") }}</el-button>
        </div>
      </template>
    </Dialog>

    <LoginOutDia v-if="visitable" v-model="visitable" @close="close"></LoginOutDia>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted, computed} from "vue";
import {TIME_COUNTPhone, TIME_COUNT, emailReg, phoneReg, passwordReg} from "@/utils/statusParams";
import Dialog from "@/components/Dialog.vue";
import {ElMessage} from "element-plus";
import {sendEmailSms, bindEmail, sendBindPhoneSms, bindPhone, updatePassword} from "@/api/usercenter";
import {useStore} from "vuex";
import CountrySelect from "@/components/CountrySelect/index.vue";
import {i18n} from "@/lang";
import LoginOutDia from "@/components/DiaPops/LoginOutDia.vue";
import ImportExcel from "@/components/DiaPops/ImportExcel.vue";
import {createRequiredRule} from "@/utils/i18nFormRules";

const store = useStore()
// 判断是否是超级管理员如果是的话 就展示
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isEnterpriseChildUser = computed(
    () => store.getters["user/isEnterpriseChildUser"]
);

const options = ref([
  {key: '简体中文', value: 'zh-CN'}, // zh_CN 简体中文
  {key: 'English', value: 'en'} // en English
]);
const langLocal = computed(() => store.state.system.langLocal)
// 改变语言
const changeLang = (e) => {
  console.log(e, '切换语言')
  store.commit('system/changeLanguage', e)
  let timer = setTimeout(() => {
    location.reload()
    clearTimeout(timer)
  }, 150)
};

// 选中的区号 默认为中国
const selectTargetPrefix = ref('CN')
const getSelectValue = (val) => {
  selectTargetPrefix.value = val.zoneCode
}

// 绑定的邮箱
const bindEmailValue = ref('')
// 绑定的手机
const bindPhoneValue = ref('')
const userInfo = computed(() => store.state.user.userInfo)
// 修改密码事件
const dialogVisible = ref(false);
const ruleForm = ref([{password: "", pass: "", checkPass: ""}]);
const ruleFormPhone = ref({})

const rulesPhone = {
  phone: [createRequiredRule('sys.tip.input.phone', 'blur')],
  code: [createRequiredRule('sys.tip.input.verify.code', 'blur')]
}
const changePassword = () => {
  dialogVisible.value = true;
};

// 表单
const ruleFormRef = ref();
const ruleFormRefEmail = ref();
const ruleFormRefPhone = ref();
// 校验
const validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(i18n.global.t('sys.tip.input.password.new')));
  } else if (passwordReg.test(value)) {
    if (ruleForm.value.checkPass !== "") {
      if (!ruleFormRef.value) return;
      ruleFormRef.value.validateField("checkPass", () => null);
    }
    callback();
  } else {
    callback(new Error(i18n.global.t("common.password.text")))
  }
};
const validatePass2 = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(i18n.global.t('40004')));
  } else if (!passwordReg.test(value)) {
    callback(new Error(i18n.global.t("common.password.text")))
  } else if (value !== ruleForm.value.pass) {
    callback(new Error(i18n.global.t('40005')));
  } else {
    callback();
  }
};

const rules = {
  password: [createRequiredRule('sys.tip.input.password', 'blur')],
  pass: [{validator: validatePass, trigger: "blur"}],
  checkPass: [{validator: validatePass2, trigger: "blur"}],
};
const rulesEmail = {
  email: [createRequiredRule('sys.tip.input.emailbox', 'blur')],
  emailCode: [createRequiredRule('sys.tip.input.verify.code', 'blur')],
};

const submit = () => {
  ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      const res = await updatePassword({
        oldPassword: ruleForm.value.password,
        newPassword: ruleForm.value.pass,
        submitPassword: ruleForm.value.checkPass
      })
      if (res.code !== 200) {
        ElMessage.error(res.message)
        return
      }
      ElMessage.success(res.message)
      await store.dispatch('user/getUserInfoForGUID')
      dialogVisible.value = false;
      ruleFormRef.value.resetFields();
    } else {
      console.log("error submit!!");
      return false;
    }
  });
};

const cancelClick = () => {
  dialogVisible.value = false;
  ruleFormRef.value.resetFields();
};

const cancelEmail = () => {
  dialogVisibleEmail.value = false;
  ruleFormRefEmail.value.resetFields();
};
const cancelPhone = () => {
  dialogVisiblePhone.value = false;
  ruleFormRefPhone.value.resetFields();
}
//邮箱
// 邮箱
const dialogVisibleEmail = ref(false);
const ruleFormEmail = ref({email: "", emailCode: ""})
const bindEmailTo = () => {
  ruleFormEmail.value.email = ''
  ruleFormEmail.value.emailCode = ''
  dialogVisibleEmail.value = true;
};
const unbindEmailTo = async () => {
  ruleFormEmail.value.email = userInfo.value.email
  ruleFormEmail.value.emailCode = ''
  dialogVisibleEmail.value = true;
}

const dialogVisiblePhone = ref(false)
// 手机绑定
const bindPhoneTo = () => {
  ruleFormPhone.value.code = ''
  ruleFormPhone.value.phone = ''
  dialogVisiblePhone.value = true
}
const unbindPhoneTo = async () => {
  ruleFormPhone.value.phone = userInfo.value.phone
  ruleFormPhone.value.code = ''
  dialogVisiblePhone.value = true
}

/**
 * 绑定邮箱
 * @type {null}
 */
const timer = ref(null);
const count = ref(0);
const show = ref(true)
const send = () => {
  if (ruleFormEmail.value.email !== '' && emailReg.test(ruleFormEmail.value.email)) {
    if (!timer.value) {
      count.value = TIME_COUNT;
      show.value = false;
      timer.value = setInterval(() => {
        if (count.value > 0 && count.value <= TIME_COUNT) {
          count.value--;
        } else {
          show.value = true;
          clearInterval(timer.value); // 清除定时器
          timer.value = null;
        }
      }, 1000)

      //   发送请求
      sendEmailSmsApis()
    }
  } else {
    ElMessage.error(i18n.global.t('sys.message.error.emailbox'));
  }
}
// 发送邮箱验证码
const sendEmailSmsApis = async () => {
  const res = await sendEmailSms({
    email: ruleFormEmail.value.email
  })
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  ElMessage.success(res.message)
}
// 绑定邮箱，重新获取用户数据
const bindEmailApis = async () => {
  const res = await bindEmail({
    email: ruleFormEmail.value.email,
    code: ruleFormEmail.value.emailCode,
    type: bindEmailValue.value !== '' ? 2 : 1
  })
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  ElMessage.success(res.message)
//   重新获取用户相关数据
  await store.dispatch('user/getUserInfoForGUID')
  await getBindEmails()
  closeEmail()
}

const closeEmail = () => {
  dialogVisibleEmail.value = false;
  ruleFormRefEmail.value.resetFields();
  bindEmailValue.value = ""
  count.value = 0;
}

// 绑定手机号
const timerPhone = ref(null);
const countPhone = ref(0);
const showPhone = ref(true)
const sendPhone = () => {
  if (ruleFormPhone.value.phone !== '' && phoneReg.test(ruleFormPhone.value.phone)) {
    if (!timerPhone.value) {
      countPhone.value = TIME_COUNTPhone;
      showPhone.value = false;
      timerPhone.value = setInterval(() => {
        if (countPhone.value > 0 && countPhone.value <= TIME_COUNTPhone) {
          countPhone.value--;
        } else {
          showPhone.value = true;
          clearInterval(timerPhone.value); // 清除定时器
          timerPhone.value = null;
        }
      }, 1000)
      //   发送请求
      sendBindPhoneSmsApis()
    }
  } else {
    ElMessage.error($t('sys.message.error.phone'));
  }
}
// 发送手机验证码
const sendBindPhoneSmsApis = async () => {
  const res = await sendBindPhoneSms({
    phone: ruleFormPhone.value.phone,
    zoneCode: selectTargetPrefix.value
  })
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  ElMessage.success(res.message)

}

// 绑定手机
const bindPhoneApis = async () => {
  const res = await bindPhone({
    phone: ruleFormPhone.value.phone,
    code: ruleFormPhone.value.code,
    type: bindPhoneValue.value !== '' ? 2 : 1,
    zoneCode: selectTargetPrefix.value
  })
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  ElMessage.success(res.message)
  await store.dispatch('user/getUserInfoForGUID')
  await getBindPhones()
  ruleFormRefPhone.value.resetFields()
  closePhone()
}

const closePhone = () => {
  dialogVisiblePhone.value = false
  ruleFormRefPhone.value.resetFields();
  bindPhoneValue.value = ""
  countPhone.value = 0;
}

// 重新获取用户信息
const getBindEmails = () => {
  const email = userInfo.value.email
  if (email) {
    bindEmailValue.value = email
  }
}
// 重新获取用户信息
const getBindPhones = () => {
  const phone = userInfo.value.phone
  if (phone) {
    bindPhoneValue.value = phone
  }
}


onMounted(async () => {
  await getBindEmails()
  await getBindPhones()
})

/**
 * 账号注销
 */
const visitable = ref(false);
const Logout = () => {
  visitable.value = true
}
const close = () => {
  visitable.value = false;
}

</script>

<style lang="less" scoped>
@import "./less/Tables.less";

.inners {
  width: auto !important;
  max-width: 1200px !important;
  height: auto;
  min-height: 640px;
}

:deep(.el-alert) {
  background: white !important;
  padding: 0px 0px !important;
}

.items {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .text {
    font-size: 14px;
    color: #999;
    margin: 10px 0 20px 16px;
  }
}

:deep(.el-alert__title) {
  font-size: 14px !important;
}

.selects {
  width: 250px;
  margin: 10px 0 20px 16px;

  :deep(.el-select) {
    width: 100% !important;
  }
}

.bottom_btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}

//#sp_input {
//  :deep(.el-form-item__content) {
//    .el-input--suffix {
//      .el-input__wrapper {
//        padding: 1px 0px 0px 11px !important;
//      }
//    }
//  }
//}

//:deep(.el-dialog__header) {
// padding-top: 20px;
//}
:deep(.el-button) {
  font-size: 14px !important;
}

:deep(.el-select) {
  font-size: 14px !important;
}

:deep(.el-form-item__label) {
  font-weight: normal !important;
}

:deep(.el-input){
  height: 26px !important;
  line-height: 26px !important;
}

:deep(.el-input--small) {
  height: 28px !important;
  line-height: 28px !important;
  font-size: 13px;
}

:deep(.el-select__wrapper){
  height: 30px !important;
  line-height: 30px !important;
  font-size: 13px !important;
}
</style>
